import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { LOGIN, FORGOT_PASSWORD, RECOVERY_PASSWORD } from 'constants/appRouting'
import AuthLayout from 'components/Layout/Auth'
import Login from './Login/Login'
import ForgotPassword from './ForgotPassword/ForgotPassword'
import RecoveryPassword from './RecoveryPassword/RecoveryPassword'

function Auth() {
  return (
    <AuthLayout>
      <Switch>
        <Route exact path={LOGIN} component={Login} />
        <Route exact path={FORGOT_PASSWORD} component={ForgotPassword} />
        <Route exact path={RECOVERY_PASSWORD} component={RecoveryPassword} />
      </Switch>
    </AuthLayout>
  )
}

export default Auth
